export default class CrmClient {
    id: number | null;
    uuid: string | null;
    name: string;
    phone: string;
    email: string;
    created_at: string | null;
    updated_at: string | null;

    constructor(data: any) {
        this.id = data?.id ?? null;
        this.uuid = data?.uuid ?? null;
        this.name = data?.name ?? '';
        this.phone = data?.phone ?? '';
        this.email = data?.email ?? '';
        this.created_at = data?.created_at ?? null;
        this.updated_at = data?.updated_at ?? null;
    }
}